"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ComparisonFeature.css");
require("./ComparisonFeature.mobile.css");
require("./ComparisonFeature.tablet.css");
require("./ComparisonFeature.desktop.css");
var icons = require("../../../../../styles/att-icons.css");
var Label_1 = require("../../../../atoms/Label");
var LabelProps_1 = require("../../../../atoms/Label/LabelProps");
var utils_1 = require("../../../../../utils/utils");
var Button_1 = require("../../../../atoms/Button");
var ButtonProps_1 = require("../../../../atoms/Button/ButtonProps");
var ComparisonFeature = /** @class */ (function (_super) {
    __extends(ComparisonFeature, _super);
    function ComparisonFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComparisonFeature.prototype.showButton = function () {
        if (this.props.options && this.props.options.showButton === false) {
            return false;
        }
        return true;
    };
    ComparisonFeature.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.comparisonFeatureContainer },
            this.props.data.checked &&
                React.createElement("span", { className: styles.iconPh, "aria-label": "Tick Icon", role: "img" },
                    React.createElement("i", { className: [styles.iconCheck, icons.attIcon, icons.attIconCheck].join(' ') })),
            !this.props.data.checked &&
                React.createElement("span", { className: styles.iconPh, "aria-label": "Cross Icon", role: "img" },
                    React.createElement("i", { className: [styles.iconClose, icons.attIcon, icons.attIconClose].join(' ') })),
            React.createElement("div", null,
                React.createElement(Label_1.default, { testId: utils_1.default(this.props.testId, 'Label'), data: { text: this.props.data.text }, options: { accessibility: (this.props.options && this.props.options.accessibility) ?
                            this.props.options.accessibility : null,
                        className: styles.lable,
                        size: LabelProps_1.LabelSizes.SMALLBODY,
                    } }),
                this.showButton() &&
                    React.createElement("div", { className: styles.dtvSeeMoreWrapper },
                        React.createElement(Button_1.default, { data: { text: this.props.data.seeDetailsBtnText }, events: { onClick: function () {
                                    _this.props.events.featureDetailEvent(_this.props.data.isCurrentPlan, _this.props.data.featureIndex);
                                } }, options: {
                                className: styles.link,
                                role: ButtonProps_1.ButtonRole.LINK,
                                type: ButtonProps_1.ButtonType.TEXT,
                            } })))));
    };
    return ComparisonFeature;
}(React.Component));
exports.default = ComparisonFeature;
//# sourceMappingURL=ComparisonFeature.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonFeature/ComparisonFeature.js
// module id = 1315
// module chunks = 8